export default __webpack_public_path__ + "static/media/socket-io.aa27363b.svg";